module.exports = __webpack_public_path__ + "img/Yenka_120X35.1828944a.png";